import Translate from "utils/Translate";
import React, { useContext } from 'react'
import ArrowRightAlt from '../icons/ArrowRightAlt';
import { AppContext } from 'contexts/AppContext';
import {createUseStyles} from 'react-jss'

const jss = createUseStyles({
    buttonLarge2: {
        backgroundColor: (styleGuide) => styleGuide.color18,
        color: (styleGuide) => styleGuide.color1,
        borderRadius: (styleGuide) => styleGuide.buttonBorderRadius,
        height: (styleGuide) => styleGuide.buttonLargeHeight,
        fontSize: (styleGuide) => styleGuide.buttonLargeFontSize,
        fontFamily: (styleGuide) => styleGuide.secondaryFontFamily,
        lineHeight: (styleGuide) => styleGuide.buttonLargeLineHeight,
        fontWeight: '600',
        border: 'none',
        padding: '14px 16px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        
        '&:hover':{
            backgroundColor: (styleGuide) => styleGuide.color16,
        },
        
        '&:disabled':{
            backgroundColor: (styleGuide) => styleGuide.color18,
            opacity: 0.7,
            cursor: 'not-allowed'
        }
    }
})

const ButtonLarge2 = (props) => {
    const { styleGuide } = useContext(AppContext)
    const classes = jss(styleGuide)
    const showIcon = (typeof props.showIcon === 'boolean') ? props.showIcon : true
    
    return (
        <button
            title={props.title || ""}
            onClick={props.onClick}
            style={{...props.style}}
            disabled={props.disabled}
            className={classes.buttonLarge2}
        >
            <Translate translationKey={props.translationKey}>{props.fallbackText || props.children}</Translate>
            {showIcon 
                ?   props.icon 
                        ? props.icon
                        : <ArrowRightAlt style={{ marginLeft:'64px' }}  fill={styleGuide.color1} />
                :   null
            }
        </button>
    )
}

export default ButtonLarge2;